/** @fileoverview Renders the list of lv1 framework cards for the active tree. */

import { Stack } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import { Level1Card } from './Level1Card'
import type { ReportLv1 } from '../types'

interface DevelopmentReportTreeProps {
  readonly items: ReportLv1[]
}

export function DevelopmentReportTree({ items }: DevelopmentReportTreeProps) {
  const { t } = useTranslation()
  const scoreTooltip = t('development_report.score_tooltip')

  return (
    <Stack spacing='sm'>
      {items.map(item => (
        <Level1Card key={item.id} item={item} scoreTooltip={scoreTooltip} />
      ))}
    </Stack>
  )
}
